const KEY = "progsity:judge:workspace:split";

const MIN = 0.3;
const MAX = 0.62;
const DEFAULT = 0.46;

/** Fraction of the workspace row given to the statement pane (`EX-PUB11`). */
export function loadWorkspaceSplitFraction(): number {
  if (typeof window === "undefined") return DEFAULT;
  try {
    const v = localStorage.getItem(KEY);
    if (v == null) return DEFAULT;
    const n = Number.parseFloat(v);
    if (Number.isFinite(n) && n >= MIN && n <= MAX) return n;
  } catch {
    /* ignore */
  }
  return DEFAULT;
}

export function saveWorkspaceSplitFraction(value: number): void {
  try {
    localStorage.setItem(KEY, String(value));
  } catch {
    /* ignore */
  }
}
